import React, { useState } from "react";
function NamePrompt({ email, onNameSet, currLang }) {
    const [name, setName] = useState('');
    const handleSubmit = async (e) => {
        e.preventDefault();
        await fetch('/api/user/name', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, name }),
        });
        onNameSet();
    };
    return (
        <div className="modal-overlay">
            <div className="modal">
                <form onSubmit={handleSubmit}>
                    <label>
                        {currLang === "IS" ? "Hæ " : "Hi "}
                        {email}
                        {currLang === "IS" ? ", hvað heitir þú?" : ", what is your name?"}<br />
                        {currLang === "IS" ? "Nafnið verður notað fyrir póstlistann. " : "Your name will be used for the mailing list! "}<br />
                        {currLang === "IS" ? "Þú ættir einungis að fá þessa spurningu einu sinni. " : "You should only be prompted once. "}<br />
                        {currLang === "IS" ? "Fullt nafn: " : "Full name: "}
                    </label>
                    <input style={{ margin: "1rem" }} value={name} onChange={e => setName(e.target.value)} required />
                    <button type="submit">{currLang === "IS" ? "Vista" : "Save"}</button>
                </form>
            </div>
        </div>
    );
};
export default NamePrompt;